import { get } from '..';

// eslint-disable-next-line no-shadow
export enum UserSortCategory {
  // eslint-disable-next-line no-unused-vars
  FIRST_NAME = 'firstName', LAST_NAME = 'lastName', EMAIL = 'email',
}
interface GetUsersProps {
  userGroupId?: string,
  roleId?: string,
  name?: string,
  email?: string,
  sortBy?: UserSortCategory,
  sortDescending?: boolean,
}

const getUsers = (params: GetUsersProps = {}) => {
  let url: string = 'users/v2';

  let iterationIndex = 0;
  Object.keys(params).forEach((key: string) => {
    if (!params[key]) return;
    iterationIndex += 1;
    url += `${iterationIndex === 1 ? '?' : '&'}${key}=${encodeURIComponent(params[key])}`;
  });

  return get(url);
};

export default getUsers;
